import { render, staticRenderFns } from "./Predictions.vue?vue&type=template&id=0403cac4&scoped=true&"
import script from "./Predictions.vue?vue&type=script&lang=js&"
export * from "./Predictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403cac4",
  null
  
)

export default component.exports